import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

function AppModal({
  show,
  onHide,
  title,
  subtitle,
  size = 'lg',
  fullscreen,
  children,
  footer,
  hideFooter = false,
}) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size={size}
      fullscreen={fullscreen || undefined}
      centered={!fullscreen}
      className="hr-modal"
      backdrop="static"
    >
      <Modal.Header closeButton className="hr-modal-header">
        <Modal.Title>
          <div className="hr-modal-title">
            <img src="/Images/icon.png" alt="" className="hr-modal-icon" />
            <div>
              <h5 className="mb-0">{title}</h5>
              {subtitle ? <small className="text-muted">{subtitle}</small> : null}
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="hr-modal-body">{children}</Modal.Body>
      {!hideFooter && (
        <Modal.Footer className="hr-modal-footer">
          {footer || (
            <Button variant="secondary" className="hr-btn-primary" onClick={onHide}>
              Close
            </Button>
          )}
        </Modal.Footer>
      )}
    </Modal>
  );
}

export default AppModal;
